<template>
    <div id="tab1" class="content easein business" :class="{ 'easein-active': opacitys }">
        <div class="title">
            Business Scope
            <div class="title-sub">业务范围</div>
        </div>
        <div class="split-title easein" :class="{ 'easein-active': opacitys }">
            <div class="line"></div>
            {{ desc.comic.configName }}
            <div class="line"></div>
        </div>
        <div class="split-desc easein" :class="{ 'easein-active': opacitys }">
            {{ desc.comic.configContent }}
        </div>
        <div class="business-banner">
            <swiper ref="businessSwiper" :options="businessSwiperOptions">
                <swiper-slide class="business-banner-row" v-for="(items, index) in signProduct" :key="index">
                    <a :href="items.audioUrl" target="_blank" class="business-item">
                        <el-image :src="items.comicImg" />
                    </a>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Business',
    props: {
        opacitys: {
            type: Boolean,
            default: false,
        },
        signProduct: {
            type: Array,
            default: () => [],
        },
        desc: {
            type: Object,
            default: () => {
                return {
                    comic: {
                        configName: '',
                        configContent: '',
                    },
                }
            },
        },
    },
    data: function () {
        return {
            businessSwiperOptions: {
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
        }
    },
    computed: {
        businessSwiper() {
            return this.$refs.businessSwiper.$swiper
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.businessSwiper.el.onmouseover = () => {
                this.businessSwiper.autoplay.stop()
            }
            this.businessSwiper.el.onmouseout = () => {
                this.businessSwiper.autoplay.start()
            }
        })
    },
}
</script>

<style lang="scss">
.business {
    .business-banner {
        width: 1600px;
        margin: 0 auto;
        margin-top: 60px;
        position: relative;
        .business-banner-row {
            display: flex;
            justify-content: space-between;
        }
        .business-banner-row-active {
            justify-content: space-around;
        }

        .business-item {
            width: 500px;
            height: 750px;
            position: relative;
            cursor: pointer;
            .el-image {
                width: 500px;
                height: 750px;
                object-fit: cover;
            }
        }
        .swiper-button-prev {
            left: -120px;
        }
        .swiper-button-next {
            right: -120px;
        }
    }
}
</style>
